import { render, staticRenderFns } from "./NutrientRequirementsTable.vue?vue&type=template&id=d6272900&scoped=true&lang=html&"
import script from "./NutrientRequirementsTable.vue?vue&type=script&lang=js&"
export * from "./NutrientRequirementsTable.vue?vue&type=script&lang=js&"
import style0 from "./NutrientRequirementsTable.vue?vue&type=style&index=0&id=d6272900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6272900",
  null
  
)

export default component.exports